import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';

import { productsAdapter } from '../../adapters/productsAdapter';
import { setFullCart } from './cartHydrationActions';

const slice = createSlice({
    name: 'itemsProductData',
    initialState: productsAdapter.getInitialState(),
    reducers: {
        setAll: (state, action: PayloadAction<ApiProduct[]>) => {
            productsAdapter.setAll(state, action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.itemsProductData);
    },
});

export default slice.reducer;

export const cartItemProductDataActions = {
    ...slice.actions,
};
